import Printer from './Printer'
export default class PrinterList {
    printers = []
    
    constructor(printers) {
        if (printers) {
            printers.map((p) => {
                this.printers.push(new Printer(p.name, p.width, p.selected))
            })
        }
    }
}